var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEnrichPhone = function SvgEnrichPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.14379 0.823529C0.968592 0.823529 0.823529 0.968592 0.823529 1.14379C0.823529 7.79008 6.2099 13.1765 12.8562 13.1765C13.0314 13.1765 13.1765 13.0314 13.1765 12.8562V10.3014C13.1765 10.1262 13.0314 9.98116 12.8562 9.98116C11.9045 9.98116 10.9752 9.82769 10.1137 9.54313L10.1093 9.54174C10.0023 9.50504 9.87422 9.53223 9.78738 9.61904L7.5 12L7.23309 11.8633C5.08529 10.7628 3.22953 8.75653 2.13559 6.60655L2 6.34014L4.38101 4.21264C4.47214 4.12148 4.49857 3.99856 4.46304 3.88286C4.17925 3.02256 4.02615 2.10173 4.02615 1.14379C4.02615 0.968592 3.88109 0.823529 3.70588 0.823529H1.14379ZM0 1.14379C0 0.513772 0.513772 0 1.14379 0H3.70588C4.33592 0 4.84968 0.513772 4.84968 1.14379C4.84968 2.01464 4.98898 2.84949 5.24613 3.62798L5.24708 3.63082L5.24798 3.63366C5.37246 4.02974 5.2815 4.47675 4.96333 4.79496L2.13559 7.38893C3.10954 9.17521 5.08068 10.6038 6.86926 11.5841L9.205 9.03674C9.51294 8.72882 9.9691 8.6241 10.374 8.76181C11.1517 9.01851 11.9932 9.15764 12.8562 9.15764C13.4862 9.15764 14 9.67141 14 10.3014V12.8562C14 13.4862 13.4862 14 12.8562 14C5.75507 14 0 8.24493 0 1.14379Z",
    fill: "#FEAC2D",
    stroke: "#FEAC2D",
    strokeWidth: 0.6
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnrichPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/enrichPhone.b545b7b5.svg";
export { ForwardRef as ReactComponent };